var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy249(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 41.6,
    cy: 36.3,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 57.6,
    cy: 36.3,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 63.1,
    cy: 50.1,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 36.7,
    cy: 50.1,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49.9,
    cy: 60.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49.6,
    cy: 47.7,
    r: 27.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 57.6,
    cy: 36.3,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 41.6,
    cy: 36.3,
    r: 3.4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M82.5,47.7c0-16.9-12.7-30.8-29.1-32.7v-3.9h-7.6V15c-16.4,1.9-29.1,15.8-29.1,32.7 c0,16.9,12.7,30.8,29.1,32.7v4.4c0,1.8,1.5,3.3,3.3,3.3h1c1.8,0,3.3-1.5,3.3-3.3v-4.4C69.8,78.5,82.5,64.6,82.5,47.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy249);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-249.31986e897e29bd9257dc202007f06d66.svg";
export { ForwardRef as ReactComponent };